/* eslint-disable no-mixed-spaces-and-tabs */
import React, { Component } from 'react';
import * as yup from 'yup';
import { Drawer, message, Select } from 'antd';
import { CloseOutlined, PlusOutlined } from '@ant-design/icons';
import { isEmpty, map } from 'lodash';
import Script from "react-load-script";
import Loader from '../../../Common/Component/Loader';
import cross_icon from "../../../../Assets/images/cross_icon.svg";
import AllState from "../../../../Assets/data/stateList.json";
import { aboutUsData } from "../../../../Assets/data/aboutUsList";
import { errorHandle } from "../../../Common/errorHandle";
import Axios from 'axios';
const { Option } = Select;
const REGULAR_EXPRESSION_EMAIL = /^(([^<>()[\]\\.,;:\s@"]+(\.[^<>()[\]\\.,;:\s@"]+)*)|(".+"))@((\[[0-9]{1,3}\.[0-9]{1,3}\.[0-9]{1,3}\.[0-9]{1,3}\])|(([a-zA-Z\-0-9]+\.)+[a-zA-Z]{2,}))$/;

class AddLead extends Component {
  constructor(props) {
    super(props);
    this.state = {
      is_btn_active: false,
      firstName: '',
      lastName: '',
      address: {},
      phone_numbers: [],
      phone: '',
      phone_type: 'mobile',
      can_send_sms: false,
      emails: [],
      email: '',
      lead_stage: 'new',
      hear_about_us: '',
      outreach: 'franchisee',
      loader: false,
      addLead: {},
      isAddService: false,
      errors: {},
      zip_code: '',
      leadError: {},
      is_dummy_email:false,
      zip_code_check: false,
      franchises: []
    }
  }


  componentDidMount = () => {
    this.genarateGibberrishEmail(); 
  }

  UNSAFE_componentWillReceiveProps = (nextProps) => {
    const {getLeads, closeDrawer} = this.props;
    // message.destroy()
    if (Object.keys(nextProps?.lead?.errors).length > 0 && nextProps?.lead?.errors !== this.props?.lead?.errors) {
      this.setState({loader: false});
      errorHandle(nextProps?.lead?.errors)
    }

    if (Object.keys(nextProps?.lead?.addlead).length > 0 && JSON.stringify(nextProps?.lead?.addlead) !== JSON.stringify(this.state.addLead)) {
      this.setState({addLead: nextProps?.lead?.addlead}, () => {
        const {addLead, isAddService} = this.state;
        if (addLead?.uuid && isAddService) {
          this.props.history.push('/residential/lead/new-service', { query: {'id': addLead?.uuid} })
          // this.props.history.push(`/residential/lead/detail`, { query: { 'id': addLead?.uuid } })
          this.setState({isAddService: false, loader: false})
        } else if (addLead?.uuid) {
          getLeads({limit: 15, offset: 0})
          closeDrawer();
          this.onClear();
          this.setState({loader: false})
        }
      });
    }

    // Check zipcode
    if (nextProps?.ZipcodeCheck && Object.keys(nextProps?.ZipcodeCheck?.data).length > 0 
      && nextProps?.ZipcodeCheck?.data?.results?.length > 0) {
      this.setState({
        zip_code_check: true,
        franchises: nextProps?.ZipcodeCheck?.data?.results,
        errors: {} 
      });
    } else {
      this.setState({
        zip_code_check: false,
        franchises: [],
        errors: {}
      });
    }

    if (Object.keys(nextProps?.GoogleApi?.getGeocode) && JSON.stringify(nextProps?.GoogleApi?.getGeocode) !== JSON.stringify(this.props?.GoogleApi?.getGeocode)) {
      this.setAddress(nextProps?.GoogleApi?.getGeocode)
    }
    this.setState({loader: false})
  }

  // set address
  setAddress = (addressObject) => {
    if (!isEmpty(addressObject)) {
      if (addressObject?.status === "OK") {
        let obj = {}, components = addressObject?.results?.[0];
        map(components?.address_components, (item) => {
          if (item?.types?.includes('administrative_area_level_2')) {
            obj = Object.assign(obj, { 'address': item.short_name })
          }
          if (item?.types?.includes('route')) {
            obj = Object.assign(obj, { 'route': item.short_name })
          }
          if (item?.types?.includes('street_number')) {
            obj = Object.assign(obj, { 'street_number': item.short_name })
          }
          if (item?.types?.includes('administrative_area_level_1')) {
            obj = Object.assign(obj, { 'state': item.short_name })
          }
          if (item?.types?.includes('locality')) {
            obj = Object.assign(obj, { 'city': item.long_name })
          }
          if (item?.types?.includes('postal_code')) {
            obj = Object.assign(obj, { 'zip_code': item.short_name })
          }
        });
        this.setState({address: obj}, () => {
          if (!obj?.address || !obj?.state || !obj.city) {
            message.error('Please enter valid address');
          }
        })
      } else {
        message.error('Something went wrong while getting address')
      }
    }
  }

  // Google Map Place API
  handleScriptLoad = () => {

    // Declare Options For Autocomplete
    const options = { componentRestrictions: { country: 'us' } };

    // Initialize Google Autocomplete
    /*global google*/ // To disable any eslint 'google not defined' errors
    const newAutoComplete = new google.maps.places.Autocomplete(
      document.getElementById('google_address'),
      options,
    );

    // Avoid paying for data that you don't need by restricting the set of
    // place fields that are returned to just the address components and formatted
    // address.
    newAutoComplete.setFields(['address_components', 'formatted_address', 'geometry']);

    // Fire Event when a suggested name is selected
    newAutoComplete.addListener('place_changed', this.handlePlaceSelect);

    this.setState({
      autocomplete: newAutoComplete,
    })
  };

  removeEmpty=(obj) =>{
    return Object.fromEntries(Object.entries(obj).filter(([_, v]) => (v !== null && v?.trim() !== "")));
  }

  // On start place change
  handlePlaceSelect = () => {
    const address= document?.getElementById('google_address')?.value;
    Axios.get(`https://maps.googleapis.com/maps/api/geocode/json`, {
      params: this.removeEmpty({
        latlng: undefined,
        address,
        key: process.env.REACT_APP_GOOGLE_PLACE_API_KEY,
      })
    }).then((res) => {
      const addressObject = res?.data?.results[0];
      let obj = {};
      map(addressObject?.address_components, (item) => {

        if (item?.types?.includes('administrative_area_level_2')) {
          obj = Object.assign(obj, { 'address': item.short_name })
        }
        if (item?.types?.includes('route')) {
          obj = Object.assign(obj, { 'route': item.long_name })
        }
        if (item?.types?.includes('street_number')) {
          obj = Object.assign(obj, { 'street_number': item.short_name })
        }
        if (item?.types?.includes('administrative_area_level_1')) {
          obj = Object.assign(obj, { 'state': item.short_name })
        }
        if (item?.types?.includes('locality')) {
          obj = Object.assign(obj, { 'city': item.long_name })
        }
        if (item?.types?.includes('postal_code')) {
          obj = Object.assign(obj, { 'zip_code': item.short_name })
        }
      // location = { lat: addressObject.geometry.location.lat(), lng: addressObject.geometry.location.lng() }
      });
      obj.address=`${obj?.street_number || ''} ${obj?.route || ''}`;
      this.setState({address: obj}, () => {
        if (!obj?.address || !obj?.state || !obj.city) {
          message.error('Please enter valid address');
        }
      })
    }).catch((err) => {
      console.log(err) });
  }

  // on address change
  onAddressChange = (e) => {
    const {address} = this.state;
    Object.assign(address, {[e.target.name]: e.target.value})
    this.setState({address});
  };

  // validate numeric input
  onNumericInputChange = (value) => {
    const reg = /^-?\d*(\.\d*)?$/;
    return ((!isNaN(value) && reg.test(value)) || value === '' || value === '-')
  };

  // format phone number
  formatPhoneNumber = (phone) => {
    if (!phone) return ''
    phone = phone?.replace(/\D/g, '');
    return phone?.substr(0, 3) + ' ' + phone?.substr(3, 3) + ' ' + phone?.substr(6);
  }

  genarateGibberrishEmail = () => {
    let newEmail = [{email: '', primary: true}]
    newEmail[0].email = this.create_UUID() + '@doody.com'
    this.setState({emails:newEmail,is_dummy_email:true});  
  }

  //on add phone or email
  onAdd = (name, type) => {
    const {phone_numbers, emails, phone, phone_type, can_send_sms, sms, email} = this.state;
    if (name === 'phone') {
      phone_numbers.push({phone: type === 'phone' ? phone : sms, can_send_sms, primary: phone_numbers?.length === 0, type: phone_type });
      this.setState({phone_numbers}, () => {this.setState({phone: '', phone_type: 'mobile', can_send_sms: false /*errors: {...errors, phone_numbers: ''}*/ }); });
    } else {
      let NewEmails = [];

      if(emails && emails.length > 0)
      {
        NewEmails = emails.filter(email => {
          return !email.email.includes('doody.com');
        });
      }

      NewEmails.push({email, primary: NewEmails?.length === 0});
      // emails.push({email, primary: emails?.length === 0});
      this.setState({emails: NewEmails,is_dummy_email:false}, () => {this.setState({email: '', /*errors: {...errors, emails: ''}*/ }); });
    }
  };

  // on primary number changed
  onPrimaryNumberChanged = (index) => {
    const {phone_numbers} = this.state;
    map(phone_numbers, x => x.primary = false)
    Object.assign(phone_numbers[index], {primary: true})
    this.setState({phone_numbers})
  }

  // on primary email changed
  onPrimaryEmailChanged = (index) => {
    const {emails} = this.state;
    map(emails, x => x.primary = false)
    Object.assign(emails[index], {primary: true})
    this.setState({emails})
  }

  //remove phone number
  removePhone = (e, index) => {
    e.preventDefault();
    let { phone_numbers } = this.state;
    const removedPhone = phone_numbers?.[index]
    phone_numbers.splice(index, 1);
    if (removedPhone?.primary && phone_numbers?.length > 0) {
      Object.assign(phone_numbers[0], {primary: true})
    }
    this.setState({ phone_numbers })
  }

  //remove phone number
  removeEmail = (e, index) => {
    e.preventDefault();
    let { emails } = this.state;
    const removedEmail = emails?.[index]
    emails.splice(index, 1);
    if (removedEmail?.primary && emails?.length > 0) {
      Object.assign(emails[0], {primary: true})
    }
    this.setState({ emails })
    if(emails.length === 0){
      this.genarateGibberrishEmail()
    }
    
  }

  // On dog detail change
  onTextChange = (e, type) => {
    const value = type === 'bool' ? e.target.checked : e.target.value;
    this.setState({ [e.target.name]: value })
  }

  // check for logged in user zipcode
  checkedLoggedInUserZipcode = (zipCode) => {
    let authUser = JSON.parse(localStorage.getItem('authUser'))
    if (!isEmpty(authUser) && authUser.user.zip_codes) {
      return authUser.user.zip_codes.includes(zipCode)
    }
    return false
  }

  // on cancel
  onCancel = () => {
    const { closeDrawer } = this.props;
    closeDrawer();
    this.onClear();
  }

  // on clear
  onClear = () => {
    this.setState({
      zip_code: '',
      email: '',
      phone: '',
      firstName: '',
      lastName: '',
      address: {},
      emails: [],
      phone_numbers: [],
      lead_stage: 'new',
      hear_about_us: '',
      outreach: 'franchisee',
      errors: {}
    }, () => {
      if (this.refs['address']) {
        this.refs['address'].value = '';
      }
      // this.validate();
    });
  }

  // validate required fields
  validate = (isAddService = false) => {
    const { 
      zip_code,
      firstName,
      lastName,
      address,
      phone_numbers,
      emails,
      lead_stage,
      outreach,
      hear_about_us 
    } = this.state;

    const schema = yup.object().shape({
      zip_code: yup.string().when('zip_code_check', {
        is: true,
        then: yup.string().required("We don’t currently have any franchises covering this area")
      }),
      zip_code: yup.string().required('The Zip Code field cannot be blank'),
      firstName: yup.string().required('First name is required'),
      lastName: yup.string().required('Last name is required'),
      lead_stage: yup.string().required('Lead stage is required.'),
      hear_about_us: yup.string().required('Lead source is required.'),
      outreach: yup.string().required('Outreach is required.')
    });
    
    const data = {
      zip_code,
      firstName,
      lastName,
      address,
      phone_numbers,
      emails,
      lead_stage,
      outreach,
      hear_about_us
    }

    setTimeout(() => {
      schema.validate(data, { abortEarly: false }).then(() => {
        this.setState({ is_btn_active: true, errors: {} });
        if (isAddService) this.onSaveAddService()
        else this.onAddLead();
      }).catch((error) => {
        let err_data = {};
        map(error.inner, (item) => {err_data[item.path] = item.message})
        console.log(err_data)
        this.setState({errors: err_data, is_btn_active: false})
      })
    }, 200);
  }

  create_UUID = () => {
    let dt = new Date().getTime();
    let uuid = 'xxxxxxxx-xxxx-4xxx-yxxx-xxxxxxxxxxxx'.replace(/[xy]/g, function(c) {
      let r = (dt + (Math.random()*16))%16 | 0;
      dt = Math.floor(dt/16);
      return (c==='x' ? r :(r&(0x3|0x8))).toString(16);
    });
    return uuid;
  }

  // on add lead
  onAddLead = () => {
    const { addLeads } = this.props;
    const { 
      zip_code,
      firstName,
      lastName,
      address,
      phone_numbers,
      emails,
      lead_stage,
      outreach,
      hear_about_us,
      zip_code_check,
      franchises,
    } = this.state;

    this.setState({loader: true, isAddService: false});
    let newEmail = [{email: '', primary: true}];
    
    if (isEmpty(emails)) {
      newEmail[0].email = this.create_UUID() + '@doody.com';
    }

    let params = {
      zip_code,
      first_name: firstName || '',
      last_name: lastName || '',
      address: [(address?.street_number && address?.route) ? {...address, address: `${address?.street_number} ${address?.route}`} : address],
      phone_numbers,
      emailaddress_set: isEmpty(emails) ? newEmail : emails,
      lead_stage,
      outreach,
      hear_about_us: [hear_about_us],
      email: isEmpty(emails) ? newEmail?.[0]?.email : emails?.[0]?.email,
      role: ['lead'],
    }

    if (isEmpty(emails)) {
      params['is_dummy_email'] = true;
    }

    if(zip_code_check)
    {
      params['field_office_uuid']= franchises[0].uuid;
    }

    addLeads(params);
  }

  // ons save and add service
  onSaveAddService = () => {
    this.onAddLead();
    this.setState({isAddService: true})
  };

  // render all state
  renderAllState = () => {
    return AllState.AllState.map((item, i) => {
      return (<Option value={item.abbreviation} key={i}>{item.name}</Option>)
    })
  }

  render() {
    const { visible } = this.props;
    const {
      zip_code,
      zip_code_check,
      franchises,
      firstName,
      lastName,
      phone_numbers,
      phone,
      phone_type,
      can_send_sms,
      emails,
      email,
      loader,
      lead_stage,
      outreach,
      hear_about_us,
      address,
      is_address_manually,
      errors
    } = this.state;

    return (
      <Drawer
        placement={'right'}
        closable={false}
        onClose={() => this.onCancel()}
        visible={visible}
        key={'right'}
        width={'400'}
        className="drawer-wrapper"
      >
        <div className="filter_drawer_wrapper rdrawer">
          {loader && <Loader />}
          <div className="card-head flex ai-center">
            <h4>{'Add New Lead'}</h4>
            <CloseOutlined onClick={() => this.onCancel()} />
          </div>
          <div className="card-row">
            <div className="card-full">
              <div className="form-group">
                <div className="fitem">
                  <label htmlFor="zip_code">Zipcode</label>
                  <input
                    name="zip_code"
                    type="text"
                    placeholder={'Zipcode'}
                    value={zip_code}
                    max={5}
                    maxLength={5}
                    onChange={(e) => this.onNumericInputChange(e.target.value) && this.onTextChange(e)}
                    onBlur={(e) => this.props.checkZipCode({ addressable_zip_codes__contains: e.target.value, close: false })}
                  />
                  {errors?.['zip_code'] ? <label className="new_err_msg"><i className="las la-info-circle"/>{zip_code===""?"The Zip Code field cannot be blank":errors?.['zip_code']}</label> : ''}
                </div>
                {zip_code !== "" && zip_code.length > 4 ? zip_code_check ? <div className="greenbox mb-30">
                  <b className="d-block">We cover this area.</b>
                  <b className="d-block">{`This is under the ${franchises[0]?.name} Franchise.`}</b>
                </div> :
                  <div className="dangerbox mb-30">
                    <b className="d-block">We don’t currently have any franchises covering this area. Save their email to notify them if we move into this area. </b>
                  </div> : ''}

                <div className="fitem half-fitem">
                  <div className="fitem half-fitem">
                    <label>First Name</label>
                    <input type="text" placeholder="First Name" name="firstName" value={firstName} onChange={(e) => this.onTextChange(e)} />
                    {errors['firstName'] ? <label className="new_err_msg"><i className="las la-info-circle" />{errors['firstName']}</label> : ''}
                  </div>
                  <div className="fitem half-fitem">
                    <label>Last Name</label>
                    <input type="text" placeholder="Last Name" name="lastName" value={lastName} onChange={(e) => this.onTextChange(e)} />
                    {errors['lastName'] ? <label className="new_err_msg"><i className="las la-info-circle" />{errors['lastName']}</label> : ''}
                  </div>

                  {/* <label htmlFor="name">Customer Name</label>
                  <input
                    name="name"
                    type="text"
                    placeholder={'Name'}
                    value={name}
                    onChange={(e) => this.onTextChange(e)}
                  />
                  {errors?.['name'] ? <label className="new_err_msg"><i className="las la-info-circle"/>{errors?.['name']}</label> : ''} */}
                </div>
                <div className="fitem">
                  <label htmlFor="address">Address(Billing)</label>
                  <div className="google_search_place">
                    <Script
                      url={`https://maps.googleapis.com/maps/api/js?key=${process.env.REACT_APP_GOOGLE_PLACE_API_KEY}&libraries=places`}
                      onLoad={() => window.requestAnimationFrame(this.handleScriptLoad)}
                    />

                    <input
                      type="text"
                      ref="address"
                      autoComplete="off"
                      placeholder={"Address"}
                      name="google_address"
                      id="google_address"
                      onChange={(e) => {
                        if (!e.target.value) {
                          this.setState({
                            address: { address: '', state: '', city: '', zip_code: '' }
                          })
                        }
                      }}
                      disabled={is_address_manually}
                    />

                    <b>or <a href="/" onClick={(e) => {
                      e.preventDefault();
                      this.setState({
                        is_address_manually: true,
                        address: { address: '', state: '', city: '', zip_code: '' },
                      }, () => {
                        if (this.refs['address']) {
                          this.refs['address'].value = '';
                        } })
                    }}><u>enter address manually</u></a></b>
                  </div>
                  {
                    is_address_manually &&
                      <div className="manually_address">
                        <a href="/#" onClick={(e) => {
                          e.preventDefault();
                          this.setState({
                            is_address_manually: false,
                            address: { address: '', state: '', city: '', zip_code: '' },
                          })
                        }}><img src={cross_icon} alt="" className="float-right mb-10" /></a>
                        <br />

                        <div className="form-group mb-20">
                          <div className="fitem">
                            <input
                              type="text"
                              placeholder="Address"
                              name="address"
                              value={address?.address}
                              onChange={(e) => this.onAddressChange(e)}
                            />
                          </div>
                          <div className="half-fitem fitem">
                            <div className="half-fitem fitem">
                              <input
                                type="text"
                                placeholder="City"
                                name="city"
                                value={address?.city}
                                onChange={(e) => this.onAddressChange(e)}
                              />
                            </div>
                            <div className="half-fitem fitem">
                              <Select
                                showArrow={true}
                                name="state"
                                placeholder="State"
                                onChange={(value) => this.onAddressChange({ target: { name: 'state', value: value } })}
                                value={address?.state || undefined}
                                virtual={false}
                              >
                                {this.renderAllState()}
                              </Select>
                            </div>
                            <div className="half-fitem fitem">
                              <input
                                type="text"
                                className='form--control'
                                placeholder="ZIP Code"
                                name="zip_code"
                                maxLength={5}
                                minLength={5}
                                onChange={(e) => this.onNumericInputChange(e.target.value) && this.onAddressChange(e)}
                                value={address?.zip_code || ''}
                              />
                            </div>
                          </div>
                        </div>
                      </div>
                  }
                  {(errors?.['address.address'] || errors?.['address.city'] || errors?.['address.state'] || errors?.['address.zip_code']) ?
                    <label className="new_err_msg"><i className="las la-info-circle"/>{'Address is required'}</label> : ''}
                </div>
                <div className="fitem">
                  <label htmlFor="phone_number">Phone Numbers</label>
                  {/* Phone numbers */}
                  <div className="mt-10 d-block mb-10">
                    {
                      map(phone_numbers, (item, index) => {
                        return (
                          <div className={'flex'} key={`checkboxPhone${index}`}>
                            <div className="fitem-check mt-5 mb-5 flex-1">
                              <input
                                type="checkbox"
                                className="fitem-ck-input"
                                id={`checkboxPhone${index}`}
                                name={`phone${index}`}
                                checked={item?.primary}
                                onChange={() => this.onPrimaryNumberChanged(index)}
                              />
                              <label htmlFor={`checkboxPhone${index}`} className="fitem-ck-txt black">
                                <b>{`+1 ${this.formatPhoneNumber(item?.phone)} ${item?.primary ? '(Primary)' : ''}`}</b>
                              </label>
                            </div>
                            <a href="/#" onClick={(e) => { this.removePhone(e, index); }} className={'float-right'} style={{alignSelf: 'center'}}><img className="icoimg" src={cross_icon} alt="" /></a>
                          </div>
                        )
                      })
                    }
                  </div>
                  <div className="fitem fitem-rinner">
                    <div className={'flex'}> {/*className="position-relative"*/}
                      <input
                        name="phone"
                        type="text"
                        placeholder={"Add New Phone Number"}
                        value={phone}
                        maxLength={"10"}
                        max={"10"}
                        onChange={(e) => this.onNumericInputChange(e.target.value) && this.onTextChange(e)} />
                      <Select
                        onChange={(e) => this.onTextChange({target: {name: 'phone_type', value: e}}) }
                        style={{marginLeft: "8px", marginRight: "8px"}}
                        name="phone_type"
                        value={phone_type}
                        placeholder="Type">
                        <Option value="home_phone">Home</Option>
                        <Option value="mobile">Mobile</Option>
                      </Select>
                      {/*fitem-ricon*/}
                      <button
                        className={`btn ${phone.length !== 10 ? 'disabled' : 'btn-warning'}`}
                        disabled={phone.length !== 10}
                        onClick={() => this.onAdd('phone', 'phone')}><PlusOutlined /></button>
                    </div>
                    {phone_type === 'mobile' ? <div className="fitem-check">
                      <input
                        type="checkbox"
                        className="fitem-ck-input"
                        id={`can_send_sms`}
                        onChange={(e) => this.onTextChange(e, 'bool')}
                        checked={can_send_sms}
                        name="can_send_sms" />
                      <label htmlFor={`can_send_sms`} className="fitem-ck-txt">{`Send SMS updates about my service to this number.`}</label>
                    </div> : ''}
                    {errors?.['phone_numbers'] ? <label className="new_err_msg"><i className="las la-info-circle"/>{errors?.['phone_numbers']}</label> : ''}
                  </div>

                  <div className="fitem mb-0">
                    <label htmlFor="address">Email addrresses</label>
                    {/* Emails */}
                    <div className="mt-10 d-block mb-10">
                      {
                        map(emails, (item, index) => item?.email && !item.email.includes('doody.com') &&
                          <div className="d-flex justify-content-between align-items-center" key={`checkboxEmail${index}`}>
                            <div className="fitem-check mt-5 mb-5">
                              <input
                                type="checkbox"
                                className="fitem-ck-input"
                                id={`checkboxEmail${index}`}
                                name={`email${index}`}
                                checked={item?.primary}
                                onChange={() => this.onPrimaryEmailChanged(index)}
                              />
                              <label htmlFor={`checkboxEmail${index}`} className="fitem-ck-txt black">
                                <b>{`${item?.email?.toLowerCase()} ${item?.primary ? '(Primary)' : ''}`}</b>
                              </label>
                            </div>
                            <a href="/#" onClick={(e) => { this.removeEmail(e, index); }} className={'float-right'} style={{alignSelf: 'center'}}><img className="icoimg" src={cross_icon} alt="" /></a>
                          </div>

                        )
                      }
                    </div>
                  </div>
                  <div className="fitem fitem-rinner">
                    <div className="position-relative">
                      <input
                        name="email"
                        type="text"
                        placeholder={"Add New Email Address"}
                        value={email}
                        onChange={(e) => this.onTextChange(e)} />
                      <button
                        className={`btn fitem-ricon ${!REGULAR_EXPRESSION_EMAIL.test(email) ? 'disabled' : 'btn-warning'}`}
                        disabled={!REGULAR_EXPRESSION_EMAIL.test(email)}
                        onClick={() => this.onAdd('email')}><PlusOutlined /></button>
                    </div>
                    {errors?.[`emails`] ? <label className="new_err_msg"><i className="las la-info-circle"/>{errors?.[`emails`]}</label> : ''}
                  </div>

                </div>
                <div className="fitem">
                  <label htmlFor="lead_stage">Lead Stage</label>
                  <Select
                    id={"lead_stage"}
                    value={lead_stage}
                    placeholder={"Lead Stage"}
                    onChange={(e) => this.onTextChange({target: {name: 'lead_stage', value: e}})}
                    dropdownClassName="md-filter">
                    <Option value="new">New</Option>
                    <Option value="contacted">Contacted</Option>
                    <Option value="interested">Interested</Option>
                    {/*<Option value="customer">Customer</Option>*/}
                  </Select>
                  {errors?.['lead_stage'] ? <label className="new_err_msg"><i className="las la-info-circle"/>{errors?.['lead_stage']}</label> : ''}
                </div>
                <div className="fitem">
                  <label htmlFor="hear_about_us">How did you hear about us</label>
                  <Select
                    id={"hear_about_us"}
                    value={hear_about_us}
                    placeholder={"How did you hear about us"}
                    onChange={(e) => this.onTextChange({target: {name: 'hear_about_us', value: e}})}
                  >
                    {aboutUsData?.map((item) => (
                      <Option id={item.id} value={item.value} key={item.id}>
                        {item.name}
                      </Option>
                    ))}
                  </Select>
                  {errors?.['hear_about_us'] ? <label className="new_err_msg"><i className="las la-info-circle"/>{errors?.['hear_about_us']}</label> : ''}
                </div>
                <div className="fitem">
                  <label htmlFor="outreach">Outreach</label>
                  <Select
                    id={"outreach"}
                    value={outreach}
                    placeholder={"Outreach"}
                    onChange={(e) => this.onTextChange({target: {name: 'outreach', value: e}})}
                    dropdownClassName="md-filter">
                    <Option value="franchisee">Franchisee</Option>
                    <Option value="call_center">Call Center</Option>
                  </Select>
                  {errors?.['outreach'] ? <label className="new_err_msg"><i className="las la-info-circle"/>{errors?.['outreach']}</label> : ''}
                </div>
              </div>
            </div>
          </div>
          <div className="footer">
            <button className={`btn btn-brand btn-bdr btn-xs`} onClick={() => this.onCancel()}>Cancel</button>
            <button
              className={`btn btn-xs btn-warning`}
              onClick={() => this.validate()}>{'Add Lead'}</button>
            <button
              className={`btn btn-xs btn-warning`}
              onClick={() => this.validate(true)}>{'Save & Add Service'}</button>
          </div>
        </div>
      </Drawer>
    )
  }
}

export default AddLead;
